// extracted by mini-css-extract-plugin
export default {"ready":"styles_ready__YPTTJ","readyToPlay":"styles_readyToPlay__ipHoM","greenCircle":"styles_greenCircle__+mzzx"};